import { MouseEvent } from 'react';
import { styled, Typography, Alert, alertClasses, Stack } from '@mui/material';
import { Error as ErrorIcon } from '@mui/icons-material';

export const DashboardVariantV2CarrierHeaderCaptionText = styled(Typography)(
  ({ theme }) => ({
    ...theme.typography.body2,
    fontWeight: theme.typography.fontWeightBold,
  }),
);

export const DashboardVariantV2CarrierHeaderLogoImg = styled('img')({
  width: 20,
  height: 20,
});

export const DashboardVariantV2CarrierHeaderErrorAlert = styled(
  (props: {
    label: string;
    value: number;
    onClick?: (event: MouseEvent<HTMLDivElement>) => void;
    className?: string;
  }) => (
    <Stack>
      <Alert
        variant="standard"
        severity="error"
        icon={<ErrorIcon />}
        className={props.className}
        onClick={props.onClick}
      >
        <Typography variant="inherit">{props.label}</Typography>

        <Typography variant="inherit">{props.value}</Typography>
      </Alert>
    </Stack>
  ),
)(({ theme }) => ({
  ...theme.typography.body2,
  fontWeight: theme.typography.fontWeightBold,
  gap: theme.spacing(2),
  alignItems: 'center',
  padding: theme.spacing(1, 1.5),
  marginLeft: theme.spacing(-1.5),
  marginRight: theme.spacing(-1.5),
  color: theme.palette.error.main,

  [`& .${alertClasses.icon}`]: {
    color: theme.palette.error.main,
    margin: 0,
    padding: 0,
  },

  [`& .${alertClasses.message}`]: {
    padding: 0,
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1),
    justifyContent: 'space-between',
    flex: 1,
  },
}));
